import { Button, InfiniteList } from '@components/common';
import { useTranslation } from 'next-i18next';
import { CardJobTalentMemo } from '@components/templates/job/Card/CardJobTalent';
import { ExtendedSWRInfiniteResponse } from '@type/swr';
import { commonStyles } from '../../common-styles';

/** Props */
export interface JobsListInfiniteProps {
  locale: Locale,
  type?: 'default' | 'top',
  jobsListData: Omit<JobsListData, 'mutate' | 'mutateSiblings' | 'mutatePage' | 'error'>,
  setCurrentListUrl: (url: string) => void,
}

type JobsListData = ExtendedSWRInfiniteResponse<
ApiSchema<'JobResult'> | ApiSchema<'ActivationResult'> | undefined,
ApiSchema<'ErrorResponse'>
>;

/**
 * @description Workplace Jobs List Infinite
 * - `locale`: *Locale* - The current app locale.
 * - `type`: *'default' | 'top'* - The type of jobs to display.
 * - `jobsListData`: - The jobs data to display (from SWR).
 */
export const WorkplaceJobsListInfinite = (props: JobsListInfiniteProps) => {
  // Destructure props
  const {
    locale,
    type = 'default',
    jobsListData,
    setCurrentListUrl,
  } = props;

  // Destructure jobsData
  const {
    data,
    size,
    sizeAsRef,
    setSize,
    isLoading,
    isEmpty,
    showLoadMore,
    isValidating,
  } = jobsListData;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *************************************
  return (
    <>
      {/* Top Jobs list */}
      <InfiniteList
        autoload={1}
        infiniteProps={{
          setSize, isEmpty, showLoadMore, sizeAsRef, isLoading,
        }}
        renderList={() => (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {data?.map((pageGroup) => {
              const viewportPage = pageGroup?.page || 1;
              return (
                pageGroup?.items?.map((jobItem, index) => (
                  <CardJobTalentMemo
                    key={`topJobs-${jobItem.slug}`}
                    job={jobItem as ApiSchema<'JobItem'>}
                    position={(viewportPage - 1) * 24 + index + 1}
                    openInModal
                    locale={locale}
                    beforeModalOpen={() => {
                      setCurrentListUrl(window.location.href);
                    }}
                    isTopJob={type === 'top'}
                  />
                ))
              );
            })}
          </div>
        )}
        renderButton={() => (
          <div className="mt-4 text-center">
            <Button
              isLoading={isValidating}
              size="sm"
              color="white"
              rounding="full"
              onClick={() => { void setSize(size + 1); }}
              className={commonStyles.showMoreButton}
            >
              {t('global.label.see_more')}
            </Button>
          </div>
        )}
      />

    </>
  );
};
